/* unplugin-vue-components disabled */import { render } from "./dms.vue?vue&type=template&id=5f5ba4e1&ts=true"
import script from "./dms.vue?vue&type=script&lang=ts"
export * from "./dms.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__